import { render } from "./DenunciaElement.vue?vue&type=template&id=58c3ee1e&scoped=true"
import script from "./DenunciaElement.vue?vue&type=script&lang=js"
export * from "./DenunciaElement.vue?vue&type=script&lang=js"

import "./DenunciaElement.vue?vue&type=style&index=0&id=58c3ee1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c3ee1e"]])

export default __exports__